export default __webpack_public_path__ + "static/media/bicycle200000.528d99b6.jpg";